import { Label } from 'cc';

declare module 'cc' {
    // eslint-disable-next-line @typescript-eslint/naming-convention
    interface Label {
        textChangeCallbackList: ((value: string) => string)[];
        registerTextChangeCallback(callback: (value: string) => string): void;
        unregisterTextChangeCallback(callback: (value: string) => string): void;
    }
}
declare module 'cc' {
    // eslint-disable-next-line @typescript-eslint/no-shadow
    namespace Label {
        enum EventType {
            TEXT_CHANGED = 'TEXT_CHANGED',
            AFTER_TEXT_CHANGED = 'AFTER_TEXT_CHANGED',
        }
    }
}

enum EventType {
    TEXT_CHANGED = 'TEXT_CHANGED',
    AFTER_TEXT_CHANGED = 'AFTER_TEXT_CHANGED',
}

Label.EventType = EventType;

Label.prototype.registerTextChangeCallback = function registerTextChangeCallback(this: Label, callback: (value: string) => string) {
    this.textChangeCallbackList = this.textChangeCallbackList ?? [];
    this.textChangeCallbackList.push(callback);
};

Label.prototype.unregisterTextChangeCallback = function unregisterTextChangeCallback(this: Label, callback: (value: string) => string) {
    if (!this.isValid || !this.textChangeCallbackList) {
        return;
    }
    const index = this.textChangeCallbackList.indexOf(callback);
    if (index !== -1) {
        this.textChangeCallbackList.splice(index, 1);
    }
};

const originalDescriptor = Object.getOwnPropertyDescriptor(Label.prototype, 'string');
const originSetter = originalDescriptor.set;
originalDescriptor.set = function set(this: Label, value: string) {
    let finalString: string = value;
    this.textChangeCallbackList?.forEach((callback) => {
        finalString = callback(finalString);
    });
    const isTextChanged = finalString !== this._string;
    if (isTextChanged) {
        this.node.emit(Label.EventType.TEXT_CHANGED, finalString);
    }
    originSetter.call(this, finalString);
    if (isTextChanged) {
        this.node.emit(Label.EventType.AFTER_TEXT_CHANGED, finalString);
    }
};
Object.defineProperty(Label.prototype, 'string', originalDescriptor);
